import React from "react";
import "../../../AllComponentCSS.css";

function JS_find() {
  return (
    <div className="tutorial-page">
      <h1>JS find</h1>
      <p>This page will cover the find topic in detail.</p>
    </div>
  );
}

export default JS_find;
